const splitTopLevelAndClauses = (query: string): string[] => {
  const clauses: string[] = []
  let currentClauseStart = 0
  let parenthesesDepth = 0

  for (let index = 0; index < query.length; index += 1) {
    const character = query[index]

    if (character === '(') {
      parenthesesDepth += 1

      continue
    }

    if (character === ')') {
      parenthesesDepth -= 1

      continue
    }

    if (parenthesesDepth === 0 && query.slice(index, index + 5) === ' AND ') {
      clauses.push(query.slice(currentClauseStart, index).trim())
      currentClauseStart = index + 5
      index += 4
    }
  }

  clauses.push(query.slice(currentClauseStart).trim())

  return clauses.filter(Boolean)
}

export const buildWisDefinitionExpression = (
  featureLayerFilterQuery: string | undefined,
  assessmentId: string
): string => {
  const clauses = featureLayerFilterQuery
    ? splitTopLevelAndClauses(featureLayerFilterQuery)
    : []

  const trailingClause = clauses.at(-1)

  if (trailingClause && /(RiskTotal|RiskDensity)/.test(trailingClause)) {
    clauses.pop()
  }

  clauses.push(`AssessmentId = ${assessmentId}`)

  return clauses.join(' AND ')
}
